import { FormEvent, useState } from "react";

import type { ManagedTenant } from "./api";

export function TenantPurgeConfirmation({
  tenant,
  busy,
  onCancel,
  onConfirm,
}: {
  tenant: ManagedTenant;
  busy: boolean;
  onCancel: () => void;
  onConfirm: (confirmation: string) => Promise<void>;
}) {
  const [confirmation, setConfirmation] = useState("");
  const matches = confirmation === tenant.name;

  function submit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    if (matches && !busy) void onConfirm(confirmation);
  }

  return (
    <div className="destructive-dialog-backdrop">
      <section className="destructive-dialog" role="dialog" aria-modal="true" aria-labelledby="tenant-purge-title">
        <h2 id="tenant-purge-title">Kunden vollständig löschen</h2>
        <p>
          Durch diese Löschung werden alle Daten, die zu diesem Kunden gehören, einschließlich aller
          Messstellen, Zuweisungen und Messwerte dauerhaft gelöscht. Möchtest du fortfahren?
        </p>
        <p className="permanent-delete-warning"><strong>Dieser Vorgang kann nicht rückgängig gemacht werden.</strong></p>
        <form onSubmit={submit}>
          <label>
            Zum Bestätigen die Kundenkennung <strong>{tenant.name}</strong> vollständig eingeben
            <input
              autoFocus
              autoComplete="off"
              spellCheck={false}
              value={confirmation}
              onChange={(event) => setConfirmation(event.target.value)}
            />
          </label>
          <div className="destructive-dialog-actions">
            <button className="secondary-button" type="button" disabled={busy} onClick={onCancel}>Abbrechen</button>
            <button className="danger-button" type="submit" disabled={!matches || busy}>
              {busy ? "Kunde wird vollständig gelöscht …" : "Kunden endgültig löschen"}
            </button>
          </div>
        </form>
      </section>
    </div>
  );
}
